<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
import ComConfig from '../src/utils/comConfig'
export default {
  data() {
    return {
      titleText: '小数答题'
    }
  },
  components: {},
  created(){
    let env = process.env.VUE_APP_Version
    if(env!=='pro'){
      ComConfig.forEach(item=>{
        if(item.env === env){
          this.titleText = item.htmlTitle
        }
      })
    }
  },
  mounted(){
    this.$nextTick(()=>{
       var titleDom = document.getElementById('PanleTitle')
       titleDom.text = this.titleText
      })
  }
}
</script>
<style lang="less">
#app {
  color: #2c3e50;
}
</style>
